import { Clock } from 'lucide-react'
import { Button } from '@highlight/ui'
import { formatUserTime, usePreferredHourCycle } from '../../utils/user-time-format'
import type { PreferredHourCycle } from '@shared/ipc/routers/BaseIpc.router'

function formatLocaleTime(time: string, hourCycle: PreferredHourCycle | null): string {
  const [h, m] = time.split(':').map(Number)
  const date = new Date()
  date.setHours(h, m, 0, 0)
  return formatUserTime(date, hourCycle)
}

interface TimeSuggestion {
  time: string
  label: string
}

const TIME_SUGGESTIONS: Array<TimeSuggestion> = [
  { time: '09:00', label: 'Morning' },
  { time: '12:00', label: 'Noon' },
  { time: '15:00', label: 'Afternoon' },
  { time: '18:00', label: 'Evening' },
  { time: '21:00', label: 'Night' },
]

interface TimeSuggestionsProps {
  selectedTime?: string
  onSelect: (time: string) => void
}

export function TimeSuggestions({ selectedTime, onSelect }: TimeSuggestionsProps) {
  const hourCycle = usePreferredHourCycle()

  return (
    <div className="flex flex-col gap-0.5">
      {TIME_SUGGESTIONS.map(({ time, label }) => {
        const isSelected = selectedTime === time
        return (
          <Button
            key={time}
            variant={isSelected ? 'secondary' : 'ghost'}
            size="lg"
            block
            className="justify-between"
            onClick={() => onSelect(time)}
          >
            <span className="flex items-center gap-2">
              <Clock className="text-foreground-placeholder" />
              {formatLocaleTime(time, hourCycle)}
            </span>
            <span className="text-foreground-secondary">{label}</span>
          </Button>
        )
      })}
    </div>
  )
}
